// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lyre-position-to-header{bottom:0;margin-bottom:-3rem;margin-right:1rem;position:absolute;right:0;z-index:10}@media (min-width:1024px){.lyre-position-to-header{margin-right:2rem}}@media (min-width:1280px){.lyre-position-to-header{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
